import React, { useEffect, useState, ChangeEvent, FC } from 'react';
import { SearchRender } from '../SearchRender/SearchRender';
import { trackActionClicked } from '../../../../api/trackActionClickedApi';
import { TrackedActions } from '../../../../models/TrackedActionsEnum';
import useFilters from '../../../../hooks/useFilters';

interface SearchInputProps {
  itsFollowed: boolean;
}

const SearchInput: FC<SearchInputProps> = ({ itsFollowed }) => {
  const { filter, dispatch, setFilter } = useFilters();
  const [valueSearched, setValueSearched] = useState('');

  const getSearchValue = (): string =>
    itsFollowed ? filter.followedProjectsFilter.searchValue : filter.allProjectsFilter.searchValue;

  useEffect(() => {
    setValueSearched(filter.common.itSearch ? getSearchValue() : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.common.itSearch]);

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const searchValue = event.target.value;
    
    const isSearchActive = searchValue.length > 0 || (
      itsFollowed
        ? filter.allProjectsFilter.searchValue.length > 0
        : filter.followedProjectsFilter.searchValue.length > 0
    );

    const updatedFilter = {
      ...filter,
      common: {
        ...filter.common,
        itSearch: isSearchActive,
      },
      ...(itsFollowed
        ? {
          followedProjectsFilter: {
            ...filter.followedProjectsFilter,
            searchValue,
          },
        }
        : {
          allProjectsFilter: {
            ...filter.allProjectsFilter,
            searchValue,
          },
        }),
    };

    dispatch(setFilter(updatedFilter));
    trackActionClicked(TrackedActions.searchProject);
  };

  return (
    <SearchRender
      placeholder="searchPlaceholder"
      onChangeHandler={onChangeHandler}
      valueSearched={valueSearched}
      debounceTimeout={1000}
    />
  );
};

export default SearchInput;
